import React from "react";
import FormPackage from "../FormPackage";

export default function AddItemComponent({ handleSubmit, isLoadingSubmit }) {
  return (
    <FormPackage
      handleSubmit={handleSubmit}
      isLoadingSubmit={isLoadingSubmit}
      initialValues={{
        name: "",
        numberOfVisit: null,
        price: null,
        packageItems: [""],
        active: true,
      }}
    />
  );
}
